import $ from "jquery";
import * as actions from "../actions/actions";
import { connect } from "react-redux";
import { hashHistory } from "react-router";
import React from "react";

import PluginToolbar from "./plugin-toolbar";
import PluginFooter from "./plugin-footer";
import Icon from "./nounproject-ui-icon";

class NounProjectPluginSignup extends React.Component {
    attemptSubmitForm(e) {
        e.preventDefault();

        let password = this.passwordInput.value,
            email = this.emailInput.value;

        this.setState({
            processing: true,
            fieldErrors: {}
        });

        let formData = $(".signup-form").serialize(); // allauth is done and somehow can't read FormData form = document.querySelector(".signup-form"); new FormData(form);

        // create a first name and append to string
        formData = `${formData}&signup_type=basic`;

        this.props.signup(formData);
    }

    clearErrors() {
        this.setState({
            processing: false,
            error: false,
            fieldErrors: {}
        });
    }

    closeAuthentication(e) {
        e.preventDefault();
        hashHistory.push("search");
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.error) {
            this.setState({
                processing: false,
                error: true,
                fieldErrors: nextProps.error
            });
        }
    }

    constructor(props) {
        super(props);
        this.state = {
            processing: false,
            error: null,
            fieldErrors: {}
        };
    }

    showLogin(e) {
        e.preventDefault();
        hashHistory.push("login");
    }

    render() {
        let submitButtonClasses = [
                "button",
                "blue",
                "full-width",
                "ui_sign-up",
                "button-process"
            ],
            inputDisabled;

        if (this.state.processing) {
            submitButtonClasses.push("processing");
            inputDisabled = "disabled";
        }

        let err,
            fld,
            errors = this.state.fieldErrors,
            fields = {
                email: {
                    className: "",
                    labelClassName: "show",
                    placeholderText: "Email",
                    labelText: "Email"
                },
                password1: {
                    className: "",
                    labelClassName: "show",
                    placeholderText: "Password",
                    labelText: "Password"
                },
                accept_terms: {
                    className: "",
                    labelClassName: "must-agree",
                    labelText: ""
                }
            };
        for (fld in errors) {
            err = errors[fld];

            if (!fields[fld]) {
                console.warn("Unknown field error", fld, err);
                fld = "password1";
            }

            fields[fld].className += " error on";
            fields[fld].labelClassName += " error on";
            fields[fld].labelText = err;
        }

        return (
            <span>
                <div className="quick-nav">
                    <PluginToolbar />
                </div>
                <div
                    className="signupView"
                    style={{
                        background: "black",
                        color: "white",
                        padding: "50px 16px 100px",
                        minHeight: "100%"
                    }}
                >
                    <style>{`
                        .signupView .text-link,
                        .signupView .text-link:hover {
                            color: white
                        }
                    `}</style>
                    <div className="plugin-menu-header">
                        <a
                            href="#"
                            className="menu-close"
                            onClick={this.closeAuthentication.bind(this)}
                            title="Cancel"
                        >
                            <Icon
                                iconId="close.svg"
                                className="icon-14"
                                color="#FFFFFF"
                            />
                        </a>
                    </div>
                    <div
                        className="info-container"
                        style={{
                            display: "flex",
                            width: "100%",
                            minWidth: "250px",
                            maxWidth: "600px",
                            margin: "0 auto",
                            flexDirection: "column",
                            textAlign: "center"
                        }}
                    >
                        <i className="ui_pro-accounts plan-pro font-large" />
                        <h3 className="font-xlarge margin-m">NounPro</h3>
                        <div className="price-container">
                            <div className="price-sign-style">
                                <div className="price-dollar-sign">$</div>
                                <div className="price-dollars-bold">39</div>
                                <div className="price-cents-underline price-pro">
                                    99
                                </div>
                                <div className="price-stacked-type">
                                    billed yearly
                                </div>
                            </div>
                        </div>
                        <ul className="weight-light padding-b-l padding-t-l">
                            <li className="padding-s">
                                Unlock over a million icons
                            </li>
                        </ul>
                    </div>
                    <form
                        action={`/accounts/signup/pro/?next=/plugin/${
                            this.props.host
                        }#/search`}
                        method="POST"
                        className="new-form dark-form signup-form plugin-form"
                        onSubmit={this.attemptSubmitForm.bind(this)}
                        style={{
                            maxWidth: "600px",
                            margin: "0 auto"
                        }}
                    >
                        <ol>
                            <li className="padding-b-s">
                                <input
                                    id="user_id"
                                    className="input"
                                    maxLength="254"
                                    name="email"
                                    type="text"
                                    required=""
                                    placeholder="Email Address"
                                    autoFocus="autofocus"
                                    ref={input => {
                                        this.emailInput = input;
                                    }}
                                    disabled={inputDisabled}
                                />
                                <label
                                    htmlFor="id_email"
                                    className={fields.email.labelClassName}
                                >
                                    {fields.email.labelText}
                                </label>
                                <label
                                    htmlFor="user_id"
                                    className="ui_icon ui_email"
                                />
                            </li>
                            <li className="padding-b-s">
                                <input
                                    id="id_password"
                                    maxLength="4096"
                                    name="password1"
                                    type="password"
                                    placeholder="Password"
                                    className="input"
                                    required=""
                                    ref={input => {
                                        this.passwordInput = input;
                                    }}
                                    disabled={inputDisabled}
                                />
                                <label
                                    htmlFor="id_password1"
                                    className={fields.password1.labelClassName}
                                >
                                    {fields.password1.labelText}
                                </label>
                                <label
                                    htmlFor="id_password"
                                    className="ui_icon ui_lock"
                                />
                            </li>
                            <li className="margin-t-xl margin-l-m">
                                <label
                                    htmlFor="receive_updates"
                                    className="display-flex flex-align-center flex-justify-start"
                                >
                                    <input
                                        id="receive_updates"
                                        name="receive_updates"
                                        className="checkbox-input"
                                        type="checkbox"
                                    />
                                    <label
                                        htmlFor="receive_updates"
                                        className="checkbox-fillin"
                                    >
                                        <i className="ui_check-mark" />
                                    </label>
                                    <span>
                                        Send me occasional emails about the
                                        Noun&nbsp;Project community.
                                    </span>
                                </label>
                            </li>
                            <li className="margin-l-m">
                                <label
                                    htmlFor="accept_terms"
                                    className="display-flex flex-align-center flex-justify-start"
                                >
                                    <input
                                        id="accept_terms"
                                        className="checkbox-input"
                                        name="accept_terms"
                                        type="checkbox"
                                    />
                                    <label
                                        htmlFor="accept_terms"
                                        className="checkbox-fillin"
                                    >
                                        <i className="ui_check-mark" />
                                    </label>
                                    <span>
                                        I agree to the{" "}
                                        <a
                                            href="/legal/#!terms-of-use/"
                                            className="text-link color-white"
                                            onClick={window.handleLink.bind(
                                                this
                                            )}
                                        >
                                            Terms of Use
                                        </a>.
                                    </span>
                                </label>
                                <label
                                    htmlFor="accept_terms"
                                    className="signup-errors"
                                >
                                    {fields.accept_terms.labelText}
                                </label>
                            </li>
                        </ol>
                        <button
                            className={submitButtonClasses.join(" ")}
                            type="submit"
                        >
                            <span>Create my account</span>
                        </button>

                        <ol
                            className="margin-t-xxl"
                            style={{ textAlign: "center" }}
                        >
                            <li className="margin-b-l">
                                <a
                                    className="already-have-account text-link"
                                    href="/plugin/#/login"
                                    onClick={this.showLogin.bind(this)}
                                >
                                    <span>I have an account</span>
                                </a>
                            </li>
                        </ol>
                    </form>
                </div>

                <PluginFooter />
            </span>
        );
    }
}

function mapStateToProps(state, ownProps) {
    let host = state.plugin.host;

    return { host };
}

module.exports = connect(
    mapStateToProps,
    {}
)(NounProjectPluginSignup);
module.exports = NounProjectPluginSignup;
